<template>
  <div>
   
       <!-- <MTop title="视频详情" /> -->

   
    <!-- <div style="padding:10px 20px;">
      <el-input class="tac" v-model="inputValue" placeholder="请输入名称/标签/简介">
        <el-button @click="submitSearch" slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div>
      <ul class="list_ul">
        <li v-for="item in topArray" :key="item.id">
          <div style="font-size:20px;" :class="['iconfont', item.icon,item.color]"></div>
          <span style="font-weight: bold;font-size:14px;">{{item.name}}</span>
        </li>
      </ul>
    </div> -->
    <!-- 详情 -->
    <div class="mob_detail">
      <div id="mobPlayer" style="width:100%;height:200px;"></div>
      <div style="padding:10px 20px;background:#fff;">
        <div class="m-title">
          <h3>{{videoInfoDetail.fileName}}</h3>
          <div
            @click="collectionVideoInfos"
            :class="['iconfont', 'iconshoucang',value == 0? '':'colActive'] "
            style="width:100px;text-align:center;"
          >{{collectName}}</div>
        </div>
        <div style="border-bottom:2px dotted #f3f3f3;padding-bottom:10px;">
          <div>
            <span>活动：</span>
            {{videoInfoDetail.activityName || '暂无'}}
          </div>
          <div>
            <span>主办单位：</span>
            {{videoInfoDetail.orgName}}
          </div>
          <div>
            <span>活动时间：</span>
            {{videoInfoDetail.activityTime || '暂无'}}
          </div>
          <div>
            <span>活动地点：</span>
            {{videoInfoDetail.address}}
          </div>
          <div>
            <span>相关人物：</span>
            {{videoInfoDetail.personName}}
          </div>
          <div>
            <span>采集人：</span>
            {{videoInfoDetail.collectUser}} /
            <span>采集时间：</span>
            {{videoInfoDetail.collectTime}}
          </div>
          <div>
            <span>上传人：</span>
            {{videoInfoDetail.createUser}} /
            <span>上传时间：</span>
            {{videoInfoDetail.createTime}}
          </div>
          <div>
            <span>浏览次数：</span>
            {{videoInfoDetail.viewcount}} /
            <span>下载次数：</span>
            {{videoInfoDetail.downloads || '0'}}
          </div>
        </div>
        <div style="padding:10px 0px;">
          <span>简介：</span>
          {{videoInfoDetail.fileIntro || '暂无简介'}}
        </div>
         <div style="padding:10px 0px;">
          <span>标签：</span>
          <el-tag style="margin-top:10px;" v-for="(item,index) in videoInfoDetail.videoOldTags" :key="index">{{item}}</el-tag>
          <br />
          <el-tag style="margin-top:10px;" v-for="(item,index) in videoInfoDetail.videoNewTags" :key="index" type="success">{{item}}</el-tag>

        </div>
      </div>
      <!-- <div class="mob-down">
        <div class="flex-row down-tab">
          <span style="flex-shrink:0;">下载1：</span>
          <div style="padding:0px 10px;">
            <div>
              体积：{{videoInfoDetail.fileSize}}KB / 比例：16:9 / 格式：{{videoInfoDetail.fileType}}/
              <span>码率：{{videoInfoDetail.fileFormat}}</span>
            </div>
            <el-button
            v-if="roleId == 1"
              @click="downloadVideo"
              type="primary"
              style="margin-top:10px;"
              size="mini"
            >立即下载</el-button>
          </div>
        </div>
        
      </div> -->
      <!-- 分享 -->
      <!-- <div class="tar padding-20 bgc-white">
      
        <span style="margin-right:20px;">分享到</span>
        <el-button size="mini" @click="shareweb(0)" icon="iconfont iconqq" circle></el-button>
        <el-button size="mini" @click="shareweb(1)" icon="iconfont iconQQkongjian" circle></el-button>
        <el-button size="mini" @click="shareweb(2)" icon="iconfont iconweibo" circle></el-button>
        <span>&nbsp;</span>
        <el-popover trigger="click" placement="top" width="300">
          <div class="offBox">
            <h4>微信里点“发现”，扫一下二维码。便可将本文分享至朋友圈。</h4>
            <div>
              <canvas id="ewmpic"></canvas>
            </div>
          </div>
          <el-button
            size="mini"
            @click="shareweb(3)"
            slot="reference"
            icon="iconfont iconweixin"
            circle
          ></el-button>
        </el-popover>
      </div>-->
    </div>
    <!-- 视频集 -->
    <div v-if="status == 1" class="bgc-white padding-20" style="margin-top:20px;">
      <div style="border-bottom:1px solid #dddddd;padding-bottom:20px;">
        <h3>{{collectionVideoInfo.title}}</h3>
        <div>
          <span>活动：</span>
          {{collectionVideoInfo.activityName}}
        </div>

        <div>
          <span>主办单位：</span>
          {{collectionVideoInfo.orgName}}
        </div>

        <div>
          <span>活动时间：</span>
          {{collectionVideoInfo.createTime}}
        </div>
        <div>
          <span>活动地点：</span>
          {{collectionVideoInfo.activityAddress}}
        </div>
        <div>
          <span>相关人物：</span>
          {{collectionVideoInfo.personName}}
        </div>
        <div>
          <span>关键词：</span>活动名称
        </div>
      </div>
      <div style="padding-top:20px;">
        <span>简介：</span>
        {{collectionVideoInfo.intro}}
      </div>
      <!-- 视频集列表 -->
      <div>
        <MobVideoColl :videoList="videoList" />
      </div>
    </div>
  </div>
</template>

<script>
import MobVideoColl from "../common/moblist";
export default {
  components: {
    MobVideoColl
  },
  data: function() {
    return {
      roleId:'',

      status: this.$route.query.status, //单视频还是视频集
      value: 0,
      inputValue: "",
      topArray: [
        {
          id: 0,
          src: require("../../assets/img/icon/play.png"),
          name: "成片库",
          icon: "iconshipin",
          color: "one"
        },
        {
          id: 1,
          src: require("../../assets/img/icon/sucai.png"),
          name: "素材库",
          icon: "iconwenjianjia",
          color: "two"
        },
        {
          id: 2,
          src: require("../../assets/img/icon/size.png"),
          name: "高级搜索",
          icon: "iconsousuo",
          color: "three"
        }
      ],
      videoPoster: "", //封面图
      videoInfoDetail: {}, //详情
      collectionVideoInfo: {}, //视频集
      videoList: [],
      video: {
        file: "",
        type: "video/mp4"
      },
      collectName: "收藏"
    };
  },
  methods: {
    submitSearch:function(){
      this.$router.push({
        path:'/mobvideolist',
        query:{
          
        }
      })
    },
    //分享到QQ
    // shareweb: function(res) {
    //   var url = window.location.href;
    //   url = encodeURIComponent(url || document.location);
    //   var title = this.videoInfoDetail.fileName;
    //   var describe = this.videoInfoDetail.fileIntro; //
    //   var pic = this.videoInfoDetail.fileLocation;
    //   var summary = this.videoInfoDetail.fileIntro; //
    //   var qq =
    //     "http://connect.qq.com/widget/shareqq/index.html?url=" +
    //     url +
    //     "&title=" +
    //     title +
    //     "&desc=" +
    //     describe +
    //     "&summary=" +
    //     summary +
    //     "&site=光明网&pics=" +
    //     pic;
    //   var qzone =
    //     "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
    //     url +
    //     "&title=" +
    //     title +
    //     "&desc=" +
    //     describe +
    //     "&summary=" +
    //     summary +
    //     "&site=光明网&pics=" +
    //     pic;
    //   var weibo =
    //     "http://service.weibo.com/share/share.php?url=" +
    //     url +
    //     "&sharesource=weibo&title=" +
    //     title +
    //     "&pic=" +
    //     pic +
    //     "&appkey=";
    //   if (res == 0) {
    //     var elink = document.createElement("a");
    //     elink.target = "_blank";
    //     elink.style.display = "none";
    //     elink.href = qq;
    //     document.body.appendChild(elink);
    //     elink.click();
    //     document.body.removeChild(elink);
    //     var res = this.$http.post(
    //       `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
    //     );
    //   }
    //   if (res == 1) {
    //     var elink = document.createElement("a");
    //     elink.target = "_blank";
    //     elink.style.display = "none";
    //     elink.href = qzone;
    //     document.body.appendChild(elink);
    //     elink.click();
    //     document.body.removeChild(elink);

    //     var res = this.$http.post(
    //       `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
    //     );
    //   }
    //   if (res == 2) {
    //     var elink = document.createElement("a");
    //     elink.target = "_blank";
    //     elink.style.display = "none";
    //     elink.href = weibo;
    //     document.body.appendChild(elink);
    //     elink.click();
    //     document.body.removeChild(elink);

    //     var res = this.$http.post(
    //       `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
    //     );
    //   }

    //   if (res == 3) {
    //     var msg = document.getElementById("ewmpic");
    //     // 将获取到的数据（val）画到msg（canvas）上
    //     var resret = window.location.href;
    //     QRCode.toCanvas(msg, resret, function(error) {
    //       console.log(error);
    //     });

    //     var res = this.$http.post(
    //       `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
    //     );
    //   }
    // },
    // 下载
    downloadVideo: function() {
      var id = "C01";
      console.log(this.$http.defaults.baseURL);
      let blobUrl = `http://39.98.255.169:9995/v1/videoDownload/videoDownloadById?vid=${this.videoInfoDetail.id}`;
      let link = document.createElement("a");
      document.body.appendChild(link);
      link.href = blobUrl;
      // link.download = "下载文件.mp4";
      link.click();
    },
    // 判断收藏状态
    videoCollectstatus: async function() {
      console.log(this.videoInfoDetail);
      var res = await this.$http.get(
        `/v1/collect/videoCollectStatus?id=${this.videoInfoDetail.id}`
      );
      var { code, data } = res.data;
      if (code == 0) {
        console.log("dddd", data);
        this.collectStatus = data;
        if (this.collectStatus == "Y") {
          this.value = 1;
          this.collectName = "取消";
          return;
        } else {
          this.value = 0;
          this.collectName = "收藏";
          return;
        }
      }
    },
    // 收藏本视频
    collectionVideoInfos: async function(id) {
      var res = await this.$http.post(
        `/v1/collect/collectionVideoInfo?id=${this.videoInfoDetail.id}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        console.log(this.value);

        if (this.value == 1) {
          // this.$message.success("已取消");
          this.$layer.toast({
            icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
            content: "取消收藏",
            time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
          });
          this.value = 0;
          this.collectName = "收藏";
        } else {
          this.value = 1;
          this.collectName = "取消";
          // this.$message.success("收藏成功！");
          this.$layer.toast({
            icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
            content: "收藏成功！",
            time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
          });
        }
      } else if (code == 40100) {
        this.$message.error(message + ", 即将跳转到登录页！");
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } else {
        this.$message.error(message);
      }
    },
    // ---ckplayer 初始化、
    init: function() {
      var that = this;
      var videoObject = {
        container: "#mobPlayer", //容器的ID或className
        variable: "player", //播放函数名称
        loaded: "loadedHandler", //当播放器加载后执行的函数
        loop: false, //播放结束是否循环播放
        cktrack: "", //字幕文件
        poster: "", //封面图片
        preview: {
          //预览图片
          file: ["", ""],
          scale: 2
        },
        mobileCkControls: false, // 是否在移动端（包括ios）环境中显示控制
        config: "", //指定配置函数
        debug: false, //是否开启调试模式
        drag: "start", //拖动的属性
        seek: 0, //默认跳转的时间
        //广告部分开始
        // adfront:
        //   "http://×××w.ckplayer.com/yytf/swf/front001.swf,http://×××w.ckplayer.com/yytf/swf/front002.swf", //前置广告
        // adfronttime: "15,15",
        // adfrontlink: "",
        // adpause:
        //   "http://×××w.ckplayer.com/yytf/swf/pause001.swf,http://×××w.ckplayer.com/yytf/swf/pause002.swf",
        // adpausetime: "5,5",
        // adpauselink: "",
        // adinsert:
        //   "http://×××w.ckplayer.com/yytf/swf/insert001.swf,http://×××w.ckplayer.com/yytf/swf/insert002.swf",
        // adinserttime: "10,10",
        // adinsertlink: "",
        // inserttime: "10,80",
        // adend:
        //   "http://×××w.ckplayer.com/yytf/swf/end001.swf,http://×××w.ckplayer.com/yytf/swf/end002.swf",
        // adendtime: "15,15",
        // adendlink: "",
        //广告部分结束
        promptSpot: [
          //提示点
          {
            words: "提示点文字01",
            time: 30
          },
          {
            words: "提示点文字02",
            time: 150
          }
        ],
        video: {
          file: "",
          type: "video/mp4"
        }
        // video: [
        //   [
        //     "http://img.ksbbs.com/asset/Mon_1703/05cacb4e02f9d9e.mp4",
        //     "video/mp4",
        //     "中文标清",
        //     0
        //   ],
        //   [
        //     "http://img.ksbbs.com/asset/Mon_1703/d0897b4e9ddd9a5.mp4",
        //     "video/mp4",
        //     "中文高清",
        //     10
        //   ],
        //   [
        //     "http://img.ksbbs.com/asset/Mon_1703/eb048d7839442d0.mp4",
        //     "video/mp4",
        //     "英文高清",
        //     0
        //   ],
        //   [
        //     "http://img.ksbbs.com/asset/Mon_1703/d30e02a5626c066.mp4",
        //     "video/mp4",
        //     "英文超清",
        //     0
        //   ]
        // ]
      };
      videoObject.poster = that.videoPoster;
      videoObject.video = that.video;
      // console.log('fffff',videoObject.poster)
      // 定义一个对象
      var player = new ckplayer(videoObject);
    },
    // 获取视频列表
    getVideoList: async function(callback) {
      var id = this.$route.query.id;
      console.log(id)
      // 单视频
      var res = await this.$http.get(`/v1/videoInfo/videoInfoDetails?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.videoInfoDetail = data;
       
        // 是否被推荐
        // this.isElite = data.isElite == "Y" ? true : false;
if (data.videoNewTags !== null) {
          this.videoInfoDetail.videoNewTags = data.videoNewTags.split(',')
        }
        if (data.videoOldTags !== null && data.videoOldTags !== '') {
          this.videoInfoDetail.videoOldTags = data.videoOldTags.split(',')
        }
        this.videoPoster = data.fileLocation;
        this.video.file = data.filePath;
        this.videoCollectstatus();
      } else {
        this.$message.error(message);
      }
      setTimeout(() => {
        callback();
      }, 200);
    },
    getVideoCollList: async function(callback) {
      // 获取视频集的信息
      var id = this.$route.query.id;
      var res = await this.$http.get(`/v1/videoInfo/groupInfoDetails?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        console.log(data);
        this.collectionVideoInfo = data;
        if (data.videoInfoList.length !== 0) {
          this.videoInfoDetail = data.videoInfoList[0];
        }
        if (data.videoInfoList[0].videoNewTags !== null) {
          this.videoInfoDetail.videoNewTags = data.videoInfoList[0].videoNewTags.split(',')
        }
        if (data.videoInfoList[0].videoOldTags !== null) {
          this.videoInfoDetail.videoOldTags = data.videoInfoList[0].videoOldTags.split(',')
        }
        // if (this.videoInfoDetail.address) {
        //   this.editAddress = this.videoInfoDetail.address.split(" ");
        // }
        // console.log("aaa", this.editAddress);
        // this.editVideoInfo = JSON.parse(JSON.stringify(data.videoInfoList[0]))
        // this.isElite = data.videoInfoList[0].isElite == "Y" ? true : false;
        this.videoList = data.videoInfoList;
        // this.playerOptions.sources[0].src = data.videoInfoList[0].filePath;
        // this.playerOptions.poster = data.videoInfoList[0].fileLocation;
        this.videoPoster = data.videoInfoList[0].fileLocation;
        this.video.file = data.videoInfoList[0].filePath;
        console.log("视频集封面图", this.videoPoster);
        this.videoCollectstatus();
      } else {
        this.$message.error(message);
      }
      setTimeout(() => {
        callback();
      }, 200);
    },
    isVideoCollection: function() {
      // console.log("isElite", this.isElite);
      var status = this.$route.query.status;
      if (status == 0) {
        // alert(1);
        this.getVideoList(this.init);
      } else {
        this.getVideoCollList(this.init);
      }
    }
  },
  created: function() {},
  mounted: function() {
    // alert(0);
    this.roleId =this.$store.state.userInfo.roleid

    this.isVideoCollection();
    document.querySelector("#app").scrollIntoView(true);
    // this.init();
    // this.videoCollectstatus();
    this.$emit('func','视频详情')
  },
  watch:{
    '$route.query.id':function(){
       document.querySelector("#app").scrollIntoView(true);
       this.isVideoCollection();
    }
  }
};
</script>

<style scoped lang="scss">
.one {
  color: #2d98fe;
}
.two {
  color: #2cd9c5;
}
.three {
  color: #00aaff;
}
.colActive {
  color: orange;
}
.list_ul {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: #fff;
  padding: 15px;
  li {
    border: 1px solid #eaeaea;
    display: flex;
    flex-direction: column;
    padding: 5px 25px;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
    // font-weight: bold;
  }
}
// 详情
.mob_detail {
  // margin-top: 20px;
  .m-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .mob-down {
    margin-top: 20px;
    background-color: #fff;
    padding: 10px 20px;
    border-bottom: 1px solid #f5f5f9;
    .down-tab {
      justify-content: flex-start;
      align-content: flex-start;
      margin-top: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/videodetail.vue